const CONFIG = {
	API_ENDPOINT: process.env.NEXT_PUBLIC_API_ENDPOINT!,
	BASE_URL: process.env.NEXT_PUBLIC_BASE_URL!,
	MEMBERFUL_CLIENT_ID: process.env.NEXT_PUBLIC_MEMBERFUL_CLIENT_ID!,
	MEMBERFUL_SITE: process.env.NEXT_PUBLIC_MEMBERFUL_SITE!,
	ROLLBAR_ACCESS_TOKEN: process.env.NEXT_PUBLIC_ROLLBAR_ACCESS_TOKEN!
};

export default CONFIG;
